import styled from "styled-components";

export const NavGroup = styled.ul`
  list-style: none;
  color: #fff !important;
  cursor: pointer;
  position: relative;
  background-color: ${props =>
    props.opened ? "rgba(0, 0, 0, 0.08)" : "transparent"};

  &.default-link-row {
    width: 33%;
    height: 7.2rem;

    &:nth-child(3) {
      li {
        &:after {
          display: none;
        }
      }
    }

    li {
      height: 7.2rem;
      text-align: center;
      position: relative;
      align-items: center;
      justify-content: center;

      &:after {
        width: 1px;
        height: 100%;
        content: "";
        position: absolute;
        background: rgba(0, 0, 0, 0.15);
        top: 0;
        right: 0;
      }

      a {
        div {
          justify-content: center;
          padding: 0;
          flex-direction: column;

          small {
            margin-top: 0.5rem;
            color: rgba(255, 255, 255, 0.5) !important;
          }
        }
      }

      i {
        margin-right: 0;
      }
    }
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }

  &:before {
    position: absolute;
    height: 100%;
    width: 0.5rem;
    background-color: #1ab394;
    content: "";
    transition: all 0.2s ease;
    opacity: ${props => (props.opened ? "1" : "0")};
  }

  p {
    font-weight: 400;
    font-size: 1.45rem;
    min-width: 25rem;
    overflow: hidden;
    transition: all 0.1s ease;

    span {
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
      color: #fff !important;

      &:before {
        width: 6rem;
        height: 1px;
        content: "";
        background: rgba(255, 255, 255, 0.2);
        position: absolute;
        bottom: -1rem;
        left: 0;
        transition: ${props =>
          props.opened ? "all 0.4s ease" : "all 0.1s ease"};
        opacity: ${props => (props.opened ? "1" : "0")};
      }
    }
  }

  li {
    display: flex;
    flex-direction: column;

    div {
      display: flex;
      align-items: center;
      padding: 2rem;

      .fa-angle-up {
        font-size: 2rem;
        align-self: center;
        color: #fff !important;
        display: ${props => (props.opened ? "block" : "none")};
        opacity: 0;
        transition: all 0.3s ease;
        position: absolute;
        right: 0.7rem;
      }

      &:hover {
        i {
          opacity: 1;
        }
      }
    }
  }

  ul {
    li {
      font-weight: 400;

      &:last-child {
        margin-bottom: 2rem;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.08);
      }

      a {
        color: rgba(255, 255, 255, 0.8) !important;
        text-decoration: none;
        font-size: 1.34rem;

        padding: 1rem 0;
        padding-left: 3rem;

        &.active {
          color: #1ab394 !important;
        }
      }
    }
  }

  small {
    color: rgba(255, 255, 255, 0.2) !important;
    display: block;
    font-size: 1.15rem;
    transition: all 0.1s ease;
    opacity: ${props => (props.opened ? "0" : "100")};
  }

  i {
    font-size: 2.7rem;
    color: rgba(255, 255, 255, 0.5) !important;
    margin-right: 1.3rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/MenuItems/styles.js